import { MasterSort } from 'components/core';

import { CSS, Flex, Typography } from '@project44/manifest-ds';
import { Skeleton } from '@project44/shared-components';

interface TableNavOwnProps {
  title: string;
  css?: CSS;
  doSearch?: () => void;
  endItem?: React.ReactNode;
  isLoading?: boolean;
}

function TableNavigation({
  doSearch,
  title,
  resultsCount = 0,
  hideCount,
  css,
  isLoading,
  endItem,
}: TableNavOwnProps & { resultsCount?: number; hideCount?: boolean }) {
  if (isLoading) {
    return (
      <Flex align="center" gap="small" css={{ height: '40px', ...css }}>
        <Skeleton css={{ width: '100%', height: '100%' }} />
      </Flex>
    );
  }

  return (
    <Flex align="center" gap="small" css={{ height: '40px', ...css }}>
      <Typography variant="subtitle">{title}</Typography>
      {!hideCount && (
        <Typography
          variant="captionBold"
          css={{
            borderRadius: '$small',
            color: '$palette-blue-600',
            backgroundColor: '$palette-blue-50',
            padding: '$x-small $small',
          }}
        >
          {resultsCount}
        </Typography>
      )}
      {doSearch && (
        <MasterSort doSearch={doSearch} sx={{ margin: '0 0 0 auto' }} />
      )}
      {endItem}
    </Flex>
  );
}

export default TableNavigation;
